import * as React from 'react';

import { useParams } from 'js/lib/useRouter';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';
import { useEnterpriseLearningPathPageData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import {
  useIsSkillPathwayLoading,
  useSkillPathway,
} from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayContext';
import EnterpriseLearningPathPageRoot from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRoot';
import EnterpriseSkillPathwayPageRoot from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseSkillPathwayPageRoot';
import EnterpriseLearningPathPageDirectorDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseLearningPathPageDirectorDataProvider';
import DisableCrawlerIndexing from 'bundles/seo/components/DisableCrawlerIndexing';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import shouldShowSkillPathways from 'bundles/unified-home-common/utils/shouldShowSkillPathways';

export const EnterpriseLearningPathPageDirector = () => {
  const program = useProgram();
  const skillPathway = useSkillPathway();
  const isSkillPathwayLoading = useIsSkillPathwayLoading();
  const learningPath = useEnterpriseLearningPathPageData();
  const { orgSlug } = useParams();

  // Redirect to the enterprise home page if the learner should not see skill pathways, or if the
  // learning path doesn't exist (no data found for the slug).
  if (learningPath === null || (!isSkillPathwayLoading && skillPathway && !shouldShowSkillPathways(program?.id))) {
    redirectClientOrServer(orgSlug ? `/organizations/${orgSlug}` : `/programs/${program?.slug}`);

    return null;
  }

  // If skill pathway returns data for learning path whose slug is in URL
  // the learning path is considered a "skill pathway" and we should render the skill pathway page.
  // TODO https://coursera.atlassian.net/browse/HOME-3969: Remove temp test once actual skill pathways are created.
  if (!isSkillPathwayLoading && skillPathway) {
    return <EnterpriseSkillPathwayPageRoot />;
  } else if (learningPath && !isSkillPathwayLoading && !skillPathway) {
    return <EnterpriseLearningPathPageRoot />;
  } else {
    return null;
  }
};

const EnterpriseLearningPathPageDirectorRoot = () => {
  return (
    <EnterpriseLearningPathPageDirectorDataProvider>
      <DisableCrawlerIndexing />
      <EnterpriseLearningPathPageDirector />
    </EnterpriseLearningPathPageDirectorDataProvider>
  );
};

export default EnterpriseLearningPathPageDirectorRoot;
